import React, { useState, useContext, useMemo, useCallback } from 'react';
// import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {
  Box,
  Paper,
  Typography,
  // Grid,
  Card,
  // CardContent,
  TextField,
  Button,
  IconButton,
  Chip,
  // Avatar,
  InputAdornment,
  Dialog,
  // DialogTitle,
  DialogContent,
  // DialogActions,
  // Tooltip,
  // LinearProgress,
  Alert,
  // Tabs,
  // Tab,
  // Divider,
  // Menu,
  // MenuItem,
  // Switch,
  // FormControlLabel,
  // Badge,
  // TableContainer,
  // Table,
  // TableHead,
  // TableRow,
  // TableCell,
  // TableBody,
  CircularProgress,
  useTheme,
  // useMediaQuery,
  styled,
  // alpha
} from '@mui/material';
import {
  Search as SearchIcon,
  // FilterList as FilterIcon,
  // Print as PrintIcon,
  // Download as DownloadIcon,
  // Email as EmailIcon,
  // Phone as PhoneIcon,
  // Message as MessageIcon,
  AttachMoney as MoneyIcon,
  AccountBalance as BalanceIcon,
  Receipt as ReceiptIcon,
  // ArrowUpward as ArrowUpIcon,
  // ArrowDownward as ArrowDownIcon,
  // MoreVert as MoreVertIcon,
  // Visibility as ViewIcon,
  // Edit as EditIcon,
  // Delete as DeleteIcon,
  Payment as PaymentIcon,
  // Add as AddIcon,
  Refresh as RefreshIcon,
  // CalendarToday as CalendarIcon,
  // TrendingUp as TrendingUpIcon,
  // TrendingDown as TrendingDownIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  // Error as ErrorIcon,
  // Info as InfoIcon,
  ArrowBack as ArrowBackIcon,
  // LightMode as LightModeIcon,
  // DarkMode as DarkModeIcon,
  FilterAlt as FilterAltIcon,
  Sort as SortIcon,
  Timeline as TimelineIcon,
  AccountCircle as AccountCircleIcon,
  CreditCard as CreditCardIcon,
  ReceiptLong as ReceiptLongIcon,
  Diamond as DiamondIcon,
  LocalAtm as LocalAtmIcon,
} from '@mui/icons-material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DataContext } from '../../context/DataContext';
import PaymentManagementDialog from '../../components/PaymentManagementDialog';
import BillSelectionDialog from '../../components/BillSelectionDialog';

// Styled components using Material-UI
const GlassCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.85)'
    : 'rgba(30, 41, 59, 0.85)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: `1px solid ${theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.3)'
    : 'rgba(148, 163, 184, 0.1)'}`,
  borderRadius: 20,
  boxShadow: theme.shadows[4],
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  overflow: 'hidden',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.mode === 'light'
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%)'
      : 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%)',
    pointerEvents: 'none',
    borderRadius: 20,
  },
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[6],
    borderColor: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.5)'
      : 'rgba(148, 163, 184, 0.2)',
  }
}));

const GlassPanel = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.7)'
    : 'rgba(30, 41, 59, 0.7)',
  backdropFilter: 'blur(40px)',
  WebkitBackdropFilter: 'blur(40px)',
  border: `1px solid ${theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.3)'
    : 'rgba(148, 163, 184, 0.1)'}`,
  borderRadius: 24,
  boxShadow: theme.shadows[4],
}));

const CustomerItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1.5),
  cursor: 'pointer',
  border: `2px solid ${active
    ? (theme.palette.mode === 'light' ? 'rgba(37, 99, 235, 0.4)' : 'rgba(96, 165, 250, 0.4)')
    : 'transparent'}`,
  borderRadius: 20,
  backgroundColor: active
    ? theme.palette.mode === 'light'
      ? 'linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(29, 78, 216, 0.05) 100%)'
      : 'linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)'
    : theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.85)'
      : 'rgba(30, 41, 59, 0.85)',
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: theme.palette.mode === 'light'
      ? 'rgba(37, 99, 235, 0.2)'
      : 'rgba(96, 165, 250, 0.2)',
    backgroundColor: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.95)'
      : 'rgba(30, 41, 59, 0.95)',
  }
}));

const CustomerAvatar = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: 12,
  background: theme.palette.mode === 'light'
    ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
    : 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
  marginRight: theme.spacing(2),
  flexShrink: 0,
}));

const StatCard = styled(GlassCard)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

// const StatIcon = styled(Box, {
//   shouldForwardProp: (prop) => prop !== 'colorType',
// })(({ theme, colorType }) => ({
//   width: 45,
//   height: 45,
//   borderRadius: 14,
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   color: theme.palette.common.white,
//   marginRight: theme.spacing(2),
//   flexShrink: 0,
//   boxShadow: theme.shadows[4],
//   background: colorType === 'primary' 
//     ? (theme.palette.mode === 'light' 
//       ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
//       : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)')
//     : colorType === 'success'
//     ? (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #34d399 0%, #10b981 100%)'
//       : 'linear-gradient(135deg, #10b981 0%, #059669 100%)')
//     : colorType === 'warning'
//     ? (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
//       : 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)')
//     : colorType === 'secondary'
//     ? (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)'
//       : 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)')
//     : (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
//       : 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)'),
// }));

const TransactionItem = styled(GlassCard, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  display: 'flex',
  padding: theme.spacing(2),
  cursor: 'pointer',
  border: `2px solid ${active
    ? (theme.palette.mode === 'light' ? 'rgba(16, 185, 129, 0.4)' : 'rgba(52, 211, 153, 0.4)')
    : 'transparent'}`,
  transition: 'all 0.3s ease',
  backgroundColor: active
    ? theme.palette.mode === 'light'
      ? 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%)'
      : 'linear-gradient(135deg, rgba(52, 211, 153, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)'
    : 'inherit',
}));

const TransactionIcon = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: 12,
  background: theme.palette.mode === 'light'
    ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(29, 78, 216, 0.1) 100%)'
    : 'linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
  flexShrink: 0,
  border: `1px solid ${theme.palette.mode === 'light'
    ? 'rgba(59, 130, 246, 0.2)'
    : 'rgba(96, 165, 250, 0.2)'}`,
}));

const DetailSection = styled(GlassCard, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})(({ theme, fullWidth }) => ({
  padding: theme.spacing(3),
  gridColumn: fullWidth ? '1 / -1' : 'auto',
  backgroundColor: theme.palette.mode === 'light'
    ? 'rgba(160, 210, 239, 0.4)'
    : 'rgba(30, 41, 59, 0.7)',
  border: `1px solid ${theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.3)'
    : 'rgba(148, 163, 184, 0.2)'}`,
  borderRadius: 16,
  backdropFilter: 'blur(10px)',
}));

const DetailContent = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'light'
    ? 'rgba(119, 189, 219, 0.4)'
    : 'rgba(30, 41, 59, 0.5)',
  padding: theme.spacing(2),
  borderRadius: 10,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  color: theme.palette.text.primary,
}));

const EmptyState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 4),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  background: theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.05)'
    : 'rgba(30, 41, 59, 0.3)',
  borderRadius: 20,
  border: `1px dashed ${theme.palette.divider}`,
}));

const DetailTableContainer = styled(Box)(({ theme }) => ({
  overflowX: 'auto',
  borderRadius: 12,
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.05)'
    : 'rgba(30, 41, 59, 0.3)',
}));

const DetailTable = styled(Box)(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  '& th': {
    padding: theme.spacing(2),
    textAlign: 'left',
    fontWeight: 600,
    color: theme.palette.text.primary,
    background: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(30, 41, 59, 0.3)',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& td': {
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& tr:hover': {
    background: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(30, 41, 59, 0.3)',
  },
  '& tr.detail-table-row': {
    fontWeight: 500,
  },
  '& .amount-cell': {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}));

const SummaryGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: theme.spacing(2),
}));

const SummaryItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  background: theme.palette.mode === 'light'
    ? 'rgba(255, 255, 255, 0.05)'
    : 'rgba(30, 41, 59, 0.3)',
  borderRadius: 12,
}));

const CustomerLedger = () => {
  const {
    customers,
    customerTransactions,
    loading,
    error,
    refresh
  } = useContext(DataContext);

  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // const gridRef = useRef();

  // State for UI
  const [searchQuery, setSearchQuery] = useState('');
  // const [selectCustomer, setSelectCustomer] = useState([]);
  // const [selectTransaction, setSelectTransaction] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState([]);
  // const [selectedCustomer, setSelectedCustomer] = useState(null);
  // const [viewDialogOpen, setViewDialogOpen] = useState(false);
  // const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  // const filterStatus = 'all';
  // const startDate = null;
  // const endDate = null;
  // const sortBy = 'balance';
  const [sortOrder, setSortOrder] = useState('desc');
  // const [tabValue, setTabValue] = useState(0);
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [selectedRows, setSelectedRows] = useState([]);
  // const [rowData, setRowData] = useState([]);
  // const [gridApi, setGridApi] = useState(null);
  // const [gridColumnApi, setGridColumnApi] = useState(null);
  const [transactionDetailOpen, setTransactionDetailOpen] = useState(false);
  const [selectedTransactionDetail, setSelectedTransactionDetail] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [selectedTransactionForPayment, setSelectedTransactionForPayment] = useState(null);
  const [billSelectionOpen, setBillSelectionOpen] = useState(false);
  const [pendingBillsForCustomer, setPendingBillsForCustomer] = useState([]);
  const { updateCustomerTransaction } = useContext(DataContext);

  const getPendingBillsForCustomer = useCallback((customerId) => {
    if (!customerId) return [];

    const customerTxns = customerTransactions.filter(t =>
      t.customer === customerId &&
      t.transactionDetails?.type !== 'cancelled'
    );

    const pendingBills = customerTxns.filter(t => {
      const pendingAmount = (t.summary?.pendingAmount || t.transactionDetails?.balanceDue || 0);
      const fineBalance = t.transactionDetails?.finePayment?.balanceFine ||
        t.summary?.fineBalance || 0;
      return (pendingAmount > 0 || fineBalance > 0) && !t.transactionDetails?.isFullyPaid;
    });

    return pendingBills;
  }, [customerTransactions]);

  const handleCollectPaymentClick = useCallback(() => {
    if (!selectedCustomerId) return;

    const pendingBills = getPendingBillsForCustomer(selectedCustomerId);

    if (pendingBills.length === 0) {
      alert('No pending bills for this customer');
      return;
    }

    if (pendingBills.length === 1) {
      // If only one bill, directly open payment dialog
      setSelectedTransactionForPayment(pendingBills[0]);
      setPaymentDialogOpen(true);
    } else {
      // If multiple bills, show selection dialog
      setPendingBillsForCustomer(pendingBills);
      setBillSelectionOpen(true);
    }
  }, [selectedCustomerId, getPendingBillsForCustomer]);

  // Add function to handle bill selection
  const handleBillSelection = useCallback((selectedBill) => {
    setBillSelectionOpen(false);
    setSelectedTransactionForPayment(selectedBill);
    setPaymentDialogOpen(true);
  }, []);

  const handleRecordPayment = async (transactionId, paymentData) => {
    const transaction = customerTransactions.find(
      (t) => t.id === transactionId
    );

    if (!transaction) {
      throw new Error("Transaction not found");
    }

    // Safe date formatter
    const formatDate = (date) => {
      if (!date) return "";
      let cleanedDate = typeof date === "string" ? date.replace(/^'/, "") : date;
      if (typeof cleanedDate === "string" && cleanedDate.includes("/")) {
        return cleanedDate;
      }
      const d = new Date(cleanedDate);
      if (isNaN(d.getTime())) return cleanedDate;
      return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    };

    const formattedPaymentDate = paymentData.date
      ? paymentData.date.replace(/^'/, "")
      : formatDate(new Date().toISOString());

    // Get EXISTING payment history from the transaction
    const existingPayments = transaction.paymentDetails?.paymentHistory || [];

    // Get payment modes from paymentData
    const paymentModes = paymentData.paymentModes || {
      cash: paymentData.cash || 0,
      online: paymentData.online || 0,
      cheque: paymentData.cheque || 0,
      other: paymentData.other || 0,
      discount: paymentData.discount || 0,
      fine: paymentData.fine || null, // { weight, purity, metal, fineWeight }
    };

    // New payment entry - includes fine & discount
    const newPaymentEntry = {
      id: `pay_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      date: `'${formattedPaymentDate}`,
      amount: paymentData.amount || 0,
      paymentModes: {
        cash: parseFloat(paymentModes.cash) || 0,
        online: parseFloat(paymentModes.online) || 0,
        cheque: parseFloat(paymentModes.cheque) || 0,
        other: parseFloat(paymentModes.other) || 0,
        discount: parseFloat(paymentModes.discount) || 0,
        advanceBreakup: paymentModes.advanceBreakup || {},
        // Fine payment entry (weight-based)
        fine: paymentModes.fine ? {
          metal: paymentModes.fine.metal || 'silver',
          weight: parseFloat(paymentModes.fine.weight) || 0,
          purity: parseFloat(paymentModes.fine.purity) || 0,
          fineWeight: (parseFloat(paymentModes.fine.weight) || 0) * (parseFloat(paymentModes.fine.purity) || 0) / 100,
        } : null,
      },
      note: paymentData.note || `Payment on ${formattedPaymentDate}`,
      recordedBy: paymentData.recordedBy || "Cashier"
    };

    // Append to existing payment history
    const updatedPayments = [...existingPayments, newPaymentEntry];

    // Calculate total cash paid (excluding fine)
    const totalPaid = updatedPayments.reduce((sum, p) => {
      const modes = p.paymentModes || {};
      return sum +
        (modes.cash || 0) +
        (modes.online || 0) +
        (modes.cheque || 0) +
        (modes.other || 0);
    }, 0);

    // Calculate total fine paid (in grams)
    const totalFinePaid = updatedPayments.reduce((sum, p) => {
      if (p.paymentModes?.fine?.fineWeight) {
        return sum + p.paymentModes.fine.fineWeight;
      }
      return sum;
    }, 0);

    const existingPaymentDetails = transaction.paymentDetails || {};
    // Calculate total discount
    // Original discount from bill creation (do NOT include payment-time discounts in this)
    // Additional payment-time discounts are tracked separately in paymentHistory entries.
    const originalBillDiscount = existingPaymentDetails.discount || 0;

    // Additional discount applied during this payment session (if user entered any)
    // const additionalDiscount = updatedPayments.reduce((sum, p) => {
    //   // Only sum discounts from payment entries created AFTER the initial bill
    //   // The initial entry has amount equal to first payment; we skip the very first entry
    //   return sum + (p.paymentModes?.discount || 0);
    // }, 0) - (existingPayments[0]?.paymentModes?.discount || 0);


    // Cumulative totals for each payment mode
    const totalCash = updatedPayments.reduce((sum, p) => sum + (p.paymentModes?.cash || 0), 0);
    const totalOnline = updatedPayments.reduce((sum, p) => sum + (p.paymentModes?.online || 0), 0);
    const totalCheque = updatedPayments.reduce((sum, p) => sum + (p.paymentModes?.cheque || 0), 0);
    const totalOther = updatedPayments.reduce((sum, p) => sum + (p.paymentModes?.other || 0), 0);

    // Original amount
    const originalAmount = transaction.transactionDetails?.originalBillAmount ||
      transaction.summary?.grandTotal ||
      0;

    // Total fine required from transaction
    const totalFineRequired = transaction.transactionDetails?.finePayment?.requiredFine ||
      transaction.calculations?.fineRequired ||
      0;

    // Calculate new cash balance (subtract cash payments + discounts)
    const newBalance = originalAmount - totalPaid - originalBillDiscount;
    const isFullyPaid = newBalance <= 0;

    // Calculate fine balance
    const newFineBalance = Math.round((totalFineRequired - totalFinePaid) * 1000) / 1000;
    const isFineFullyPaid = newFineBalance <= 0;

    const formattedTransactionDate = formatDate(transaction.date);

    // const existingDiscount = existingPaymentDetails.discount || 0;

    const existingAdvancePayment = existingPaymentDetails.advancePayment || {
      enabled: false,
      total: 0,
      breakup: {}
    };

    // Final updated transaction
    const updatedTransaction = {
      ...transaction,
      date: formattedTransactionDate.startsWith("'")
        ? formattedTransactionDate
        : `'${formattedTransactionDate}`,
      paymentDetails: {
        ...existingPaymentDetails,
        paymentHistory: updatedPayments,
        totalPaymentDone: totalPaid,
        cash: totalCash,
        online: totalOnline,
        cheque: totalCheque,
        other: totalOther,
        discount: originalBillDiscount,
        advancePayment: existingAdvancePayment,
        // Add fine payment summary
        finePayment: {
          totalFineRequired: totalFineRequired,
          totalFinePaid: totalFinePaid,
          balanceFine: newFineBalance,
          entries: updatedPayments
            .filter(p => p.paymentModes?.fine)
            .map(p => p.paymentModes.fine),
        },
      },
      summary: {
        ...transaction.summary,
        paymentDone: totalPaid,
        pendingAmount: newBalance > 0 ? newBalance : 0,
        fineRequired: totalFineRequired,
        finePaid: totalFinePaid,
        fineBalance: newFineBalance > 0 ? newFineBalance : 0,
      },
      transactionDetails: {
        ...transaction.transactionDetails,
        balanceDue: newBalance > 0 ? newBalance : 0,
        isFullyPaid: isFullyPaid && isFineFullyPaid,
        paymentStatus: (isFullyPaid && isFineFullyPaid) ? "paid" : "partial",
        lastPaymentDate: `'${formattedPaymentDate}`,
        lastPaymentAmount: newPaymentEntry.amount,
        finePayment: {
          ...(transaction.transactionDetails?.finePayment || {}),
          totalFinePaid: totalFinePaid,
          balanceFine: newFineBalance,
        },
      },
      updated_at: new Date().toISOString()
    };

    console.log("Updating transaction with payment:", updatedTransaction);

    const result = await updateCustomerTransaction(transactionId, updatedTransaction);

    if (result.success) {
      refresh();
      return result;
    }

    throw new Error(result.message || "Failed to record payment");
  };

  const handlePaymentComplete = (updatedData) => {
    // Refresh the customer data
    refresh();
    // Close the dialog
    setPaymentDialogOpen(false);
    setSelectedTransactionForPayment(null);
  };

  const customersWithBalances = useMemo(() => {
    if (!customers || !customerTransactions) return [];

    return customers.map(customer => {
      const customerTxns = customerTransactions.filter(
        transaction => transaction.customer === customer.id &&
          transaction.transactionDetails?.type !== 'cancelled'
      );

      let totalDue = 0;
      let totalPaid = 0;
      let lastTransactionDate = null;
      let overdueAmount = 0;
      let totalFineRequired = 0;
      let totalFinePaid = 0;
      let recentTransactions = [];

      customerTxns.forEach(transaction => {
        const transactionDate = new Date(transaction.date);
        const grandTotal = transaction.summary?.grandTotal || 0;
        const paymentDone = transaction.summary?.paymentDone || 0;
        const pendingAmount = transaction.summary?.pendingAmount || 0;

        // Fine tracking
        const fineRequired = transaction.transactionDetails?.finePayment?.requiredFine ||
          transaction.summary?.fineRequired ||
          0;
        const finePaid = transaction.transactionDetails?.finePayment?.totalFinePaid ||
          transaction.summary?.finePaid ||
          0;
        const fineBalance = transaction.transactionDetails?.finePayment?.balanceFine ||
          transaction.summary?.fineBalance ||
          0;

        totalDue += grandTotal;
        totalPaid += paymentDone;
        totalFineRequired += fineRequired;
        totalFinePaid += finePaid;

        if (pendingAmount > 0) {
          overdueAmount += pendingAmount;
        }

        if (!lastTransactionDate || transactionDate > lastTransactionDate) {
          lastTransactionDate = transactionDate;
        }

        recentTransactions.push({
          id: transaction.id,
          date: transaction.date,
          billNo: transaction.transactionDetails?.billNo || 'N/A',
          amount: grandTotal,
          paid: paymentDone,
          pending: pendingAmount,
          fineRequired: fineRequired,
          finePaid: finePaid,
          fineBalance: fineBalance,
          type: transaction.transactionDetails?.type || 'detailed',
          gst: transaction.transactionDetails?.gstApplicable || false,
          isCancelled: transaction.transactionDetails?.type === 'cancelled'
        });
      });

      recentTransactions?.sort((a, b) => {
        if (a.timestamp && b.timestamp) return b.timestamp - a.timestamp;
        if (a.createdAt && b.createdAt) return new Date(b.createdAt) - new Date(a.createdAt);
        return new Date(b.date) - new Date(a.date);
      });

      const balance = totalDue - totalPaid;
      const fineBalance = Math.round((totalFineRequired - totalFinePaid) * 1000) / 1000;
      const daysOverdue = lastTransactionDate
        ? Math.floor((new Date() - lastTransactionDate) / (1000 * 60 * 60 * 24))
        : 0;

      return {
        ...customer,
        id: customer.id,
        customerId: customer.id,
        totalTransactions: customerTxns.length,
        totalDue,
        totalPaid,
        balance,
        overdueAmount,
        lastTransactionDate,
        daysOverdue,
        recentTransactions: recentTransactions.slice(0, 5),
        // Fine tracking
        totalFineRequired,
        totalFinePaid,
        fineBalance,
        hasFineBalance: fineBalance > 0,
        hasCashBalance: balance > 0,
        status: (balance > 0 || fineBalance > 0)
          ? balance > 10000 ? 'high' : 'medium'
          : 'paid'
      };
    });
  }, [customers, customerTransactions]);

  const getCustomersWithPendingPayments = useCallback(() => {
    if (!customers || !customerTransactions) return [];

    return customers.filter(customer => {
      const customerTrans = customerTransactions.filter(t =>
        t.customer === customer.id &&
        t.transactionDetails?.type !== 'cancelled'
      );
      return customerTrans.some(t => {
        const pendingAmount = t.summary?.pendingAmount || 0;
        const fineBalance = t.transactionDetails?.finePayment?.balanceFine ||
          t.summary?.fineBalance || 0;
        return pendingAmount > 0 || fineBalance > 0;
      });
    });
  }, [customers, customerTransactions]);

  // Get customers with pending payments - memoized
  const customersWithPendingPayments = useMemo(() => {
    const pendingCustomers = getCustomersWithPendingPayments();
    return pendingCustomers.map(customer => {
      const customerData = customersWithBalances.find(c => c.id === customer.id);
      return customerData || customer;
    });
  }, [getCustomersWithPendingPayments, customersWithBalances]);

  // Filter customers based on search and filters
  // const filteredCustomers = useMemo(() => {
  //   let filtered = customersWithPendingPayments;

  //   if (searchQuery) {
  //     const query = searchQuery.toLowerCase();
  //     filtered = filtered.filter(customer =>
  //       customer.name?.toLowerCase().includes(query) ||
  //       customer.contact.toString()?.toLowerCase().includes(query) ||
  //       customer.address?.toLowerCase().includes(query)
  //     );
  //   }

  //   if (filterStatus !== 'all') {
  //     switch (filterStatus) {
  //       case 'overdue':
  //         filtered = filtered.filter(customer => customer.daysOverdue > 30);
  //         break;
  //       case 'high':
  //         filtered = filtered.filter(customer => customer.balance > 10000);
  //         break;
  //       case 'recent':
  //         filtered = filtered.filter(customer => customer.daysOverdue <= 7);
  //         break;
  //     }
  //   }

  //   if (startDate && endDate) {
  //     filtered = filtered.filter(customer => {
  //       if (!customer.lastTransactionDate) return true;
  //       const transDate = new Date(customer.lastTransactionDate);
  //       return transDate >= startDate && transDate <= endDate;
  //     });
  //   }

  //   filtered?.sort((a, b) => {
  //     let aValue, bValue;

  //     switch (sortBy) {
  //       case 'balance':
  //         aValue = a.balance;
  //         bValue = b.balance;
  //         break;
  //       case 'name':
  //         aValue = a.name?.toLowerCase();
  //         bValue = b.name?.toLowerCase();
  //         break;
  //       case 'overdue':
  //         aValue = a.daysOverdue;
  //         bValue = b.daysOverdue;
  //         break;
  //       case 'lastPayment':
  //         aValue = a.lastTransactionDate ? new Date(a.lastTransactionDate) : new Date(0);
  //         bValue = b.lastTransactionDate ? new Date(b.lastTransactionDate) : new Date(0);
  //         break;
  //       default:
  //         aValue = a.balance;
  //         bValue = b.balance;
  //     }

  //     if (sortOrder === 'desc') {
  //       return bValue - aValue;
  //     } else {
  //       return aValue - bValue;
  //     }
  //   });

  //   return filtered;
  // }, [customersWithPendingPayments, searchQuery, filterStatus, startDate, endDate, sortBy, sortOrder]);

  // Calculate summary statistics
  // const summaryStats = useMemo(() => {
  //   const totalBalance = filteredCustomers.reduce((sum, customer) => sum + customer.balance, 0);
  //   const totalOverdue = filteredCustomers.reduce((sum, customer) => sum + customer.overdueAmount, 0);
  //   const totalCustomers = filteredCustomers.length;
  //   const averageBalance = totalCustomers > 0 ? totalBalance / totalCustomers : 0;

  //   return {
  //     totalBalance,
  //     totalOverdue,
  //     totalCustomers,
  //     averageBalance
  //   };
  // }, [filteredCustomers]);

  // Get selected customer details
  const selectedCustomerDetails = useMemo(() => {
    return customersWithBalances.find(c => c.id === selectedCustomerId);
  }, [selectedCustomerId, customersWithBalances]);

  // Get transactions for selected customer
  const selectedCustomerTransactions = useMemo(() => {
    if (!selectedCustomerId) return [];

    const transactions = customerTransactions.filter(t => t.customer === selectedCustomerId);

    return transactions.sort((a, b) => {
      if (a.timestamp && b.timestamp) {
        return b.timestamp - a.timestamp;
      }
      if (a.createdAt && b.createdAt) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }
      if (a.transactionTime && b.transactionTime) {
        const dateTimeA = new Date(`${a.date} ${a.transactionTime}`);
        const dateTimeB = new Date(`${b.date} ${b.transactionTime}`);
        return dateTimeB - dateTimeA;
      }
      try {
        const dateA = new Date(a.date.split('/').reverse().join('-'));
        const dateB = new Date(b.date.split('/').reverse().join('-'));
        return dateB - dateA;
      } catch {
        return 0;
      }
    });
  }, [selectedCustomerId, customerTransactions]);

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  // Handle view transaction detail
  const handleViewTransactionDetail = useCallback((transactionId) => {
    const transaction = customerTransactions.find(t => t.id === transactionId);
    if (transaction) {
      setSelectedTransactionDetail(transaction);
      setTransactionDetailOpen(true);
      // setSelectTransaction(transactionId);
    }
  }, [customerTransactions]);

  // Render customer list sidebar
  const renderCustomerList = () => {
    if (customersWithPendingPayments.length === 0) {
      return (
        <EmptyState>
          <DiamondIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          {loading ? 'Loading customers...' : 'No customers with pending payments'}
        </EmptyState>
      );
    }

    const filtered = customersWithPendingPayments.filter(customer => {
      const name = (customer.name || 'Unknown Customer').toLowerCase();
      return name.includes(searchQuery.toLowerCase());
    });

    if (filtered.length === 0) {
      return (
        <EmptyState>
          <SearchIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          No customers match your search
        </EmptyState>
      );
    }

    return filtered.map(customer => {
      const customerTxns = customerTransactions.filter(t => t.customer === customer.id);
      const hasFine = customer.fineBalance > 0;

      return (
        <CustomerItem
          key={customer.id}
          active={selectedCustomerId === customer.id}
          onClick={() => setSelectedCustomerId(customer.id)}
        >
          <CustomerAvatar>
            <AccountCircleIcon />
          </CustomerAvatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {customer.name || 'Unknown Customer'}
              </Typography>
              <Chip
                label={`${customerTxns.length} txn`}
                size="small"
                sx={{
                  fontSize: 11,
                  height: 20,
                  bgcolor: theme.palette.mode === 'light'
                    ? 'rgba(37, 99, 235, 0.1)'
                    : 'rgba(96, 165, 250, 0.1)',
                  color: 'primary.main',
                  fontWeight: 600,
                }}
              />
              {/* FINE BALANCE INDICATOR */}
              {hasFine && (
                <Chip
                  icon={<DiamondIcon sx={{ fontSize: 12 }} />}
                  label={`${customer.fineBalance.toFixed(2)}g`}
                  size="small"
                  sx={{
                    fontSize: 10,
                    height: 20,
                    bgcolor: theme.palette.mode === 'light'
                      ? 'rgba(139, 92, 246, 0.15)'
                      : 'rgba(167, 139, 250, 0.15)',
                    color: theme.palette.mode === 'light' ? '#7c3aed' : '#a78bfa',
                    fontWeight: 600,
                  }}
                />
              )}
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
              {customer.contact || 'No contact'}
            </Typography>
            {/* Balance indicators */}
            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
              {customer.balance > 0 && (
                <Chip
                  label={`₹${customer.balance.toFixed(0)}`}
                  size="small"
                  sx={{
                    fontSize: 10,
                    height: 18,
                    bgcolor: 'warning.main',
                    color: 'white',
                    fontWeight: 600,
                  }}
                />
              )}
              {hasFine && (
                <Chip
                  label={`${customer.fineBalance.toFixed(2)}g fine`}
                  size="small"
                  sx={{
                    fontSize: 10,
                    height: 18,
                    bgcolor: 'info.main',
                    color: 'white',
                    fontWeight: 600,
                  }}
                />
              )}
            </Box>
          </Box>
        </CustomerItem>
      );
    });
  };

  // Update the renderTransactionList function - add a "Collect Payment" button
  const renderTransactionList = () => {
    if (!selectedCustomerId) {
      return (
        <EmptyState>
          <ReceiptLongIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          Select a customer to view transactions
        </EmptyState>
      );
    }

    // Filter out cancelled transactions from the list
    const activeTransactions = selectedCustomerTransactions.filter(
      t => t.transactionDetails?.type !== 'cancelled'
    );

    if (activeTransactions.length === 0) {
      return (
        <EmptyState>
          <ReceiptIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          No active transactions found
        </EmptyState>
      );
    }

    return activeTransactions.map(transaction => {
      const date = transaction.date || 'Unknown Date';
      const grandTotal = transaction.summary ? transaction.summary.grandTotal : 0;
      const paymentDone = transaction.summary ? transaction.summary.paymentDone : 0;
      const billNo = transaction.transactionDetails ? transaction.transactionDetails.billNo : 'N/A';
      const items = transaction.items ? transaction.items.map(item => item.name).join(', ') : 'No items';
      const pendingAmount = transaction.summary ? transaction.summary.pendingAmount : 0;
      const fineBalance = transaction.transactionDetails?.finePayment?.balanceFine ||
        transaction.summary?.fineBalance || 0;
      const hasFineBalance = fineBalance > 0;
      const isFullyPaid = (transaction.transactionDetails?.isFullyPaid || pendingAmount === 0) && !hasFineBalance;

      return (
        <TransactionItem
          key={transaction.id}
          active={selectedTransactionDetail?.id === transaction.id}
          onClick={() => handleViewTransactionDetail(transaction.id)}
        >
          <TransactionIcon>
            {pendingAmount > 0 ?
              <WarningIcon color="warning" sx={{ fontSize: 24 }} /> :
              <CheckCircleIcon color="success" sx={{ fontSize: 24 }} />
            }
          </TransactionIcon>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {/* Rest of your JSX remains the same */}
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              mb: 1.5
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Typography variant="subtitle1" sx={{ color: 'text.primary' }}>
                  Bill #{billNo}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  {date}
                </Typography>
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary' }}>
                {formatCurrency(grandTotal)}
              </Typography>
            </Box>
            <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
              <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                {transaction.transactionDetails?.gstApplicable && (
                  <Chip
                    label={transaction.transactionDetails?.gstType === 'igst' ? 'IGST' : 'GST'}
                    size="small"
                    sx={{
                      fontSize: 9,
                      height: 18,
                      bgcolor: transaction.transactionDetails?.gstType === 'igst'
                        ? (theme.palette.mode === 'light' ? '#fef3c7' : '#422006')
                        : (theme.palette.mode === 'light' ? '#dbeafe' : '#1e3a5f'),
                      color: transaction.transactionDetails?.gstType === 'igst'
                        ? (theme.palette.mode === 'light' ? '#d97706' : '#fbbf24')
                        : (theme.palette.mode === 'light' ? '#2563eb' : '#60a5fa'),
                      fontWeight: 600,
                    }}
                  />
                )}
                <Chip
                  label={pendingAmount > 0 ? 'Pending' : 'Paid'}
                  size="small"
                  sx={{
                    bgcolor: pendingAmount > 0 ? 'warning.main' : 'success.main',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: 12,
                  }}
                />
              </Box>
              <Typography variant="body2" sx={{
                color: 'text.secondary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1
              }}>
                {items?.length > 50 ? `${items.slice(0, 50)}...` : items}
              </Typography>
            </Box>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: 'space-between'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <LocalAtmIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
                    Paid: {formatCurrency(paymentDone)}
                  </Typography>
                </Box>
                {hasFineBalance && (
                  <Chip
                    icon={<DiamondIcon />}
                    label={`Fine Due: ${fineBalance.toFixed(3)}g`}
                    size="small"
                    sx={{
                      bgcolor: 'info.main',
                      color: 'white',
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  />
                )}
                {pendingAmount > 0 && (
                  <Chip
                    icon={<WarningIcon />}
                    label={`Due: ${formatCurrency(pendingAmount)}`}
                    size="small"
                    sx={{
                      bgcolor: 'warning.main',
                      color: 'white',
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  />
                )}
              </Box>

              {/* Collect Payment button only for pending non-cancelled transactions */}
              {(pendingAmount > 0 || hasFineBalance) && !isFullyPaid && (
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<PaymentIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedTransactionForPayment(transaction);
                    setPaymentDialogOpen(true);
                  }}
                  sx={{
                    borderRadius: 2,
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    padding: '4px 12px',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                    }
                  }}
                >
                  Collect Payment
                </Button>
              )}
            </Box>
          </Box>
        </TransactionItem>
      );
    });
  };

  const renderStatsCards = () => {
    if (!selectedCustomerDetails) return null;

    const openingBalance = selectedCustomerDetails.openingBalance || 0;
    const totalBuying = selectedCustomerDetails.totalDue || 0;
    const totalPaid = selectedCustomerDetails.totalPaid || 0;
    const totalDiscount = selectedCustomerTransactions.reduce((sum, t) => {
      // Original bill discount
      const billDiscount = t.paymentDetails?.discount || 0;

      // Additional discounts applied during later payments
      const history = t.paymentDetails?.paymentHistory || [];
      const additionalDiscounts = history
        .slice(1)  // skip the very first entry (initial payment) — its discount is part of the bill
        .reduce((s, p) => s + (p.paymentModes?.discount || 0), 0);

      return sum + billDiscount + additionalDiscounts;
    }, 0);
    const totalPending = Number(selectedCustomerDetails.balance) + Number(openingBalance);
    const fineBalance = selectedCustomerDetails.fineBalance || 0;
    const hasFineBalance = fineBalance > 0;

    const stats = [
      { label: 'Opening Balance', value: openingBalance, icon: <TimelineIcon />, colorType: 'primary' },
      { label: 'Total Supplied', value: totalBuying, icon: <TimelineIcon />, colorType: 'primary' },
      { label: 'Total Discount', value: totalDiscount, icon: <MoneyIcon />, colorType: 'secondary' },
      { label: 'Total Received', value: totalPaid, icon: <BalanceIcon />, colorType: 'success' },
      { label: 'Pending Payment', value: totalPending, icon: <PaymentIcon />, colorType: 'warning' },
    ];

    // Check if there are any pending transactions (cash or fine)
    const hasPendingTransactions = selectedCustomerTransactions.some(t => {
      const pendingAmount = t.summary?.pendingAmount || t.transactionDetails?.balanceDue || 0;
      const fineBal = t.transactionDetails?.finePayment?.balanceFine || t.summary?.fineBalance || 0;
      return pendingAmount > 0 || fineBal > 0;
    });

    return (
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
        gap: 1
      }}>
        {stats.map((stat, index) => (
          <StatCard key={index}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{
                color: 'text.secondary',
                mb: 0.5,
                display: 'block'
              }}>
                {stat.label}
              </Typography>
              <Typography variant="h6" sx={{
                fontWeight: 700,
                color: 'text.primary'
              }}>
                {formatCurrency(stat.value)}
              </Typography>
            </Box>
          </StatCard>
        ))}

        {/* FINE BALANCE CARD */}
        {hasFineBalance && (
          <StatCard sx={{
            background: theme.palette.mode === 'light'
              ? 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(124, 58, 237, 0.08) 100%)'
              : 'linear-gradient(135deg, rgba(167, 139, 250, 0.15) 0%, rgba(139, 92, 246, 0.08) 100%)',
            border: `1px solid ${theme.palette.mode === 'light'
              ? 'rgba(139, 92, 246, 0.3)'
              : 'rgba(167, 139, 250, 0.3)'}`,
          }}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{
                color: 'text.secondary',
                mb: 0.5,
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
              }}>
                <DiamondIcon sx={{ fontSize: 14 }} />
                Fine Balance
              </Typography>
              <Typography variant="h6" sx={{
                fontWeight: 700,
                color: theme.palette.mode === 'light' ? '#7c3aed' : '#a78bfa'
              }}>
                {fineBalance.toFixed(3)} g
              </Typography>
            </Box>
          </StatCard>
        )}

        {hasPendingTransactions && (
          <Button
            variant="contained"
            startIcon={<PaymentIcon />}
            onClick={handleCollectPaymentClick}
            sx={{
              borderRadius: 2,
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': {
                background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
              }
            }}
          >
            Collect Payment
          </Button>
        )}
      </Box>
    );
  };

  // Render transaction detail view
  const renderTransactionDetail = () => {
    if (!selectedTransactionDetail) return null;

    const transaction = selectedTransactionDetail;
    const customer = customers.find(c => c.id === transaction.customer) || {};
    const items = transaction.items || [];
    const calculatedTotals = transaction.calculatedTotals || {};
    const paymentDetails = transaction.paymentDetails || {};
    const summary = transaction.summary || {};
    const transactionDetails = transaction.transactionDetails || {};

    // ---------- FINE PAYMENT DATA ----------
    // Pull fine payment info from multiple possible locations for safety
    const finePaymentData = paymentDetails?.finePayment || {};
    const fineRequired =
      finePaymentData.totalFineRequired ||
      transactionDetails?.finePayment?.requiredFine ||
      summary?.fineRequired ||
      0;
    const finePaid =
      finePaymentData.totalFinePaid ||
      transactionDetails?.finePayment?.totalFinePaid ||
      summary?.finePaid ||
      0;
    const fineBalance =
      finePaymentData.balanceFine ??
      transactionDetails?.finePayment?.balanceFine ??
      summary?.fineBalance ??
      0;
    const fineEntries = finePaymentData.entries || [];

    // ---------- BUILD PAYMENT BREAKDOWN ROWS ----------
    // Each row: { label, value, isFine, isBalance }
    const paymentBreakdownRows = [
      { label: 'Cash', value: paymentDetails.cash || 0, isFine: false },
      { label: 'Online', value: paymentDetails.online || 0, isFine: false },
      { label: 'Cheque', value: paymentDetails.cheque || 0, isFine: false },
      { label: 'Discount', value: paymentDetails.discount || 0, isFine: false },
      { label: 'Other', value: paymentDetails.other || 0, isFine: false },
    ];

    // Add fine rows only when relevant
    if (finePaid > 0) {
      paymentBreakdownRows.push({
        label: 'Fine Paid',
        value: finePaid,
        isFine: true,
        isBalance: false,
      });
    }
    if (fineBalance > 0) {
      paymentBreakdownRows.push({
        label: 'Fine Balance',
        value: fineBalance,
        isFine: true,
        isBalance: true,
      });
    }

    return (
      <GlassPanel sx={{ p: 4, maxHeight: '85vh', overflowY: 'auto' }}>
        {/* ---------- HEADER ---------- */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 4,
          }}
        >
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => setTransactionDetailOpen(false)}
            sx={{
              borderRadius: 12,
              padding: '10px 24px',
              bgcolor:
                theme.palette.mode === 'light'
                  ? 'rgba(255, 255, 255, 0.85)'
                  : 'rgba(30, 41, 59, 0.85)',
              border: `1px solid ${theme.palette.mode === 'light'
                ? 'rgba(255, 255, 255, 0.3)'
                : 'rgba(148, 163, 184, 0.1)'
                }`,
              color: 'text.primary',
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': {
                bgcolor:
                  theme.palette.mode === 'light'
                    ? 'rgba(37, 99, 235, 0.1)'
                    : 'rgba(96, 165, 250, 0.1)',
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(37, 99, 235, 0.3)'
                    : 'rgba(96, 165, 250, 0.3)',
              },
            }}
          >
            Back to transactions
          </Button>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {/* GST Chip */}
            {transactionDetails?.gstType && transactionDetails?.gstApplicable && (
              <Chip
                label={
                  transactionDetails.gstType === 'igst' ? 'IGST' : 'CGST/SGST'
                }
                size="small"
                sx={{
                  fontWeight: 600,
                  fontSize: 11,
                  height: 24,
                  bgcolor:
                    transactionDetails.gstType === 'igst'
                      ? theme.palette.mode === 'light'
                        ? '#fef3c7'
                        : '#422006'
                      : theme.palette.mode === 'light'
                        ? '#dbeafe'
                        : '#1e3a5f',
                  color:
                    transactionDetails.gstType === 'igst'
                      ? theme.palette.mode === 'light'
                        ? '#d97706'
                        : '#fbbf24'
                      : theme.palette.mode === 'light'
                        ? '#2563eb'
                        : '#60a5fa',
                  border: `1px solid ${transactionDetails.gstType === 'igst'
                    ? theme.palette.mode === 'light'
                      ? '#f59e0b'
                      : '#78350f'
                    : theme.palette.mode === 'light'
                      ? '#3b82f6'
                      : '#1e3a5f'
                    }`,
                }}
              />
            )}

            {/* Fine Balance Chip */}
            {fineBalance > 0 && (
              <Chip
                icon={<DiamondIcon />}
                label={`Fine Due: ${fineBalance.toFixed(3)}g`}
                size="small"
                sx={{
                  fontWeight: 600,
                  fontSize: 11,
                  height: 24,
                  bgcolor: 'info.main',
                  color: 'white',
                }}
              />
            )}

            {/* Payment Status Chip */}
            <Chip
              label={
                summary.pendingAmount > 0 || fineBalance > 0 ? 'PENDING' : 'PAID'
              }
              sx={{
                fontWeight: 600,
                letterSpacing: 0.5,
                padding: '8px 20px',
                fontSize: 13,
                height: 32,
                bgcolor:
                  summary.pendingAmount > 0 || fineBalance > 0
                    ? 'warning.main'
                    : 'success.main',
                color: 'white',
              }}
            />
          </Box>
        </Box>

        {/* ---------- MAIN GRID ---------- */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 3,
          }}
        >
          {/* ===== Customer Details ===== */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 3,
                color: 'text.primary',
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <AccountCircleIcon /> Customer Details
            </Typography>
            <DetailContent>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: 'text.secondary', fontWeight: 500, pr: 2 }}
                >
                  Name
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: 'text.primary' }}
                >
                  {customer.name || 'Unknown'}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: 'text.secondary', fontWeight: 500, pr: 2 }}
                >
                  Contact
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: 'text.primary' }}
                >
                  {customer.contact || 'N/A'}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: 'text.secondary', fontWeight: 500, pr: 2 }}
                >
                  Address
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: 'text.primary' }}
                >
                  {customer.address || 'N/A'}
                </Typography>
              </Box>
            </DetailContent>
          </DetailSection>

          {/* ===== Transaction Details ===== */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 3,
                color: 'text.primary',
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <ReceiptIcon /> Transaction Details
            </Typography>
            <DetailContent>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: 'text.secondary', fontWeight: 500, pr: 2 }}
                >
                  Date
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: 'text.primary' }}
                >
                  {transaction.date || 'N/A'}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: 'text.secondary', fontWeight: 500, pr: 2 }}
                >
                  Bill No
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: 'text.primary' }}
                >
                  {transactionDetails.billNo || 'N/A'}
                </Typography>
              </Box>
            </DetailContent>
          </DetailSection>

          {/* ===== Items Table ===== */}
          <DetailSection fullWidth>
            <Typography
              variant="h6"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 3,
                color: 'text.primary',
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <DiamondIcon /> Items ({items.length})
            </Typography>
            {items.length ? (
              <DetailTableContainer>
                <DetailTable component="table">
                  <Box component="thead">
                    <Box component="tr">
                      {[
                        'Item #',
                        'Name',
                        'HUID',
                        'Weight',
                        'Rate',
                        'Labour',
                        'Total',
                      ].map((header) => (
                        <Box component="th" key={header}>
                          {header}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box component="tbody">
                    {items.map((item, idx) => {
                      const weightNum = parseFloat(item.weight) || 0;
                      const priceNum = parseFloat(item.price) || 0;
                      const metalRateNum = parseFloat(item.metalRate) || 0;
                      // Saved items store labour under `labour`; fall back to `makingCharges` for safety
                      const labourNum =
                        parseFloat(item.labour ?? item.makingCharges) || 0;

                      // Per-piece (MRP) item — no weight, price set directly
                      const isPerPiece =
                        item.isPerPieceItem ||
                        (weightNum === 0 && priceNum > 0);

                      // Fine-based item — has weight but no metal rate (price = labour × weight)
                      // const isFineBased = !isPerPiece && metalRateNum === 0 && weightNum > 0;

                      // ----- Weight display -----
                      const weightDisplay = isPerPiece
                        ? `${item.numberOfPieces || 1} pcs`
                        : weightNum > 0
                          ? `${weightNum.toFixed(3)} g`
                          : '-';

                      // ----- Rate display (metal rate per gram) -----
                      const rateDisplay = isPerPiece
                        ? 'MRP'
                        : metalRateNum > 0
                          ? `₹${metalRateNum.toFixed(2)}`
                          : '—'; // fine-based item has no metal rate

                      // ----- Labour display -----
                      // For per-piece: labour is the total labour on the piece
                      // For fine-based: labour is per gram
                      // For weight-based: labour is per gram
                      const labourDisplay =
                        labourNum > 0 ? `₹${labourNum.toFixed(2)}` : '—';

                      return (
                        <Box
                          component="tr"
                          key={item.itemNumber || idx}
                          className="detail-table-row"
                        >
                          <Box component="td">{item.itemNumber || idx + 1}</Box>
                          <Box component="td">{item.name || '-'}</Box>
                          <Box component="td">{item.huid || '-'}</Box>
                          <Box component="td">{weightDisplay}</Box>
                          <Box component="td">{rateDisplay}</Box>
                          <Box component="td">{labourDisplay}</Box>
                          <Box component="td" className="amount-cell">
                            {formatCurrency(priceNum)}
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </DetailTable>
              </DetailTableContainer>
            ) : (
              <EmptyState>No items found</EmptyState>
            )}
          </DetailSection>

          {/* ===== Payment Summary ===== */}
          <DetailSection fullWidth>
            <Typography
              variant="h6"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 3,
                color: 'text.primary',
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <BalanceIcon /> Payment Summary
            </Typography>
            <SummaryGrid>
              <SummaryItem>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Subtotal
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: 'text.primary' }}
                >
                  {formatCurrency(calculatedTotals.subtotal || 0)}
                </Typography>
              </SummaryItem>

              {/* GST Display */}
              {summary?.igst > 0 ? (
                <SummaryItem>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    IGST (3%)
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: 'text.primary' }}
                  >
                    {formatCurrency(summary.igst || 0)}
                  </Typography>
                </SummaryItem>
              ) : (
                summary?.cgst !== 0 && (
                  <>
                    <SummaryItem>
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                      >
                        CGST (1.5%)
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 700, color: 'text.primary' }}
                      >
                        {formatCurrency(summary.cgst || 0)}
                      </Typography>
                    </SummaryItem>
                    <SummaryItem>
                      <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                      >
                        SGST (1.5%)
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 700, color: 'text.primary' }}
                      >
                        {formatCurrency(summary.sgst || 0)}
                      </Typography>
                    </SummaryItem>
                  </>
                )
              )}

              <SummaryItem>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Grand Total
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: 'text.primary' }}
                >
                  {formatCurrency(summary.grandTotal || 0)}
                </Typography>
              </SummaryItem>

              <SummaryItem>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Payment Done
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: 'success.main' }}
                >
                  {formatCurrency(summary.paymentDone || 0)}
                </Typography>
              </SummaryItem>

              <SummaryItem>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Pending Amount
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: 'warning.main' }}
                >
                  {formatCurrency(summary.pendingAmount || 0)}
                </Typography>
              </SummaryItem>

              {/* Fine Summary Items */}
              {fineRequired > 0 && (
                <SummaryItem>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                    }}
                  >
                    <DiamondIcon sx={{ fontSize: 14 }} /> Fine Required
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.mode === 'light'
                        ? '#7c3aed'
                        : '#a78bfa',
                    }}
                  >
                    {fineRequired.toFixed(3)} g
                  </Typography>
                </SummaryItem>
              )}

              {finePaid > 0 && (
                <SummaryItem>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                    }}
                  >
                    <DiamondIcon sx={{ fontSize: 14 }} /> Fine Paid
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: 'success.main' }}
                  >
                    {finePaid.toFixed(3)} g
                  </Typography>
                </SummaryItem>
              )}

              {fineBalance > 0 && (
                <SummaryItem>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                    }}
                  >
                    <DiamondIcon sx={{ fontSize: 14 }} /> Fine Balance
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: 'warning.main' }}
                  >
                    {fineBalance.toFixed(3)} g
                  </Typography>
                </SummaryItem>
              )}
            </SummaryGrid>
          </DetailSection>

          {/* ===== Payment Breakdown (with Fine rows) ===== */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 3,
                color: 'text.primary',
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <CreditCardIcon /> Payment Breakdown
            </Typography>
            <DetailContent>
              {paymentBreakdownRows.map((row, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 1,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: row.isFine ? 'info.main' : 'text.secondary',
                      fontWeight: 500,
                      pr: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                    }}
                  >
                    {row.isFine && <DiamondIcon sx={{ fontSize: 14 }} />}
                    {row.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      color: row.isBalance
                        ? 'warning.main'
                        : row.isFine
                          ? 'info.main'
                          : 'text.primary',
                    }}
                  >
                    {row.isFine
                      ? `${row.value.toFixed(3)} g`
                      : formatCurrency(row.value || 0)}
                  </Typography>
                </Box>
              ))}

              {/* Fine Payment Entries Breakdown (optional detail) */}
              {fineEntries.length > 0 && (
                <Box sx={{ mt: 2, pt: 2, borderTop: `2px dashed ${theme.palette.divider}` }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'text.secondary',
                      fontWeight: 600,
                      display: 'block',
                      mb: 1,
                    }}
                  >
                    Fine Payment Entries:
                  </Typography>
                  {fineEntries.map((entry, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: 0.5,
                        pl: 2,
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{ color: 'text.secondary' }}
                      >
                        {idx + 1}. {entry.metal || 'Silver'} —{' '}
                        {entry.weight?.toFixed(3) || '0'}g @{' '}
                        {entry.purity?.toFixed(1) || '0'}%
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ fontWeight: 600, color: 'info.main' }}
                      >
                        = {entry.fineWeight?.toFixed(3) || '0'}g fine
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </DetailContent>
          </DetailSection>

          {/* ===== Advance Payments ===== */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 3,
                color: 'text.primary',
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <LocalAtmIcon /> Advance Payments
            </Typography>
            <DetailContent>
              {[
                {
                  label: 'Advance Cash',
                  value: paymentDetails?.advancePayment?.breakup?.cash,
                },
                {
                  label: 'Advance Online',
                  value: paymentDetails?.advancePayment?.breakup?.online,
                },
                {
                  label: 'Advance Old Gold',
                  value: paymentDetails?.advancePayment?.breakup?.oldGold,
                },
                {
                  label: 'Advance Old Silver',
                  value: paymentDetails?.advancePayment?.breakup?.oldSilver,
                },
                {
                  label: 'Advance Other',
                  value: paymentDetails?.advancePayment?.breakup?.custom,
                },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 1,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ color: 'text.secondary', fontWeight: 500, pr: 2 }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, color: 'text.primary' }}
                  >
                    {formatCurrency(item.value || 0)}
                  </Typography>
                </Box>
              ))}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 2,
                  mt: 1,
                  borderTop: `2px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: 'text.primary', fontWeight: 700 }}
                >
                  Total Advance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: 'success.main' }}
                >
                  {formatCurrency(paymentDetails?.advancePayment?.total || 0)}
                </Typography>
              </Box>
            </DetailContent>
          </DetailSection>
        </Box>
      </GlassPanel>
    );
  };

  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} thickness={4} sx={{ color: 'primary.main', mb: 3 }} />
          <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 600 }}>
            Loading customer data...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 3,
        p: 3,
      }}>
        <Alert severity="error" sx={{
          bgcolor: theme.palette.mode === 'light'
            ? 'rgba(255, 255, 255, 0.85)'
            : 'rgba(30, 41, 59, 0.85)',
          backdropFilter: 'blur(20px)',
          border: `1px solid ${theme.palette.mode === 'light'
            ? 'rgba(255, 255, 255, 0.3)'
            : 'rgba(148, 163, 184, 0.1)'}`,
          borderRadius: 20,
        }}>
          Error loading data: {error}
        </Alert>
        <Button
          variant="contained"
          onClick={refresh}
          startIcon={<RefreshIcon />}
          sx={{
            borderRadius: 12,
            background: theme.palette.mode === 'light'
              ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
              : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
            color: 'white',
            fontWeight: 600,
            padding: '12px 32px',
            boxShadow: theme.shadows[4],
          }}
        >
          Retry Loading Data
        </Button>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{
        minHeight: '100vh',
        p: 2.5,
        position: 'relative',
        overflowX: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: theme.palette.mode === 'light'
            ? `radial-gradient(circle at 20% 80%, rgba(139, 92, 246, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(59, 130, 246, 0.15) 0%, transparent 50%)`
            : `radial-gradient(circle at 20% 80%, rgba(139, 92, 246, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(96, 165, 250, 0.15) 0%, transparent 50%)`,
          zIndex: -1,
          pointerEvents: 'none',
        }
      }}>
        {/* Main Layout */}
        <Box sx={{
          display: 'flex',
          gap: 3,
          height: 'calc(100vh - 80px)',
          [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
          }
        }}>
          {/* Customer List Sidebar */}
          <GlassPanel sx={{
            width: 400,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            [theme.breakpoints.down('lg')]: {
              width: '100%',
              height: 400,
            }
          }}>
            <Box sx={{
              p: 2.5,
              borderBottom: `1px solid ${theme.palette.divider}`,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                  Customers
                </Typography>
                <Chip
                  label={`${customersWithPendingPayments.length} pending`}
                  size="small"
                  sx={{
                    fontWeight: 500,
                    bgcolor: 'warning.main',
                    color: 'white',
                  }}
                />
              </Box>
              <IconButton
                size="small"
                onClick={() => setShowFilters(!showFilters)}
                sx={{
                  bgcolor: showFilters
                    ? (theme.palette.mode === 'light'
                      ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                      : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)')
                    : (theme.palette.mode === 'light'
                      ? 'rgba(255, 255, 255, 0.85)'
                      : 'rgba(30, 41, 59, 0.85)'),
                  border: `1px solid ${theme.palette.mode === 'light'
                    ? 'rgba(255, 255, 255, 0.3)'
                    : 'rgba(148, 163, 184, 0.1)'}`,
                  color: showFilters ? 'Blue' : 'Grey',
                }}
              >
                <FilterAltIcon />
              </IconButton>
            </Box>

            {showFilters && (
              <GlassCard sx={{ m: 2, p: 2 }}>
                <Box sx={{ mb: 1.5 }}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search customers..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 12,
                        background: theme.palette.mode === 'light'
                          ? 'rgba(255, 255, 255, 0.05)'
                          : 'rgba(30, 41, 59, 0.3)',
                        transition: 'all 0.3s ease',
                        color: 'text.primary',
                        '&:hover': {
                          background: theme.palette.mode === 'light'
                            ? 'rgba(255, 255, 255, 0.1)'
                            : 'rgba(30, 41, 59, 0.4)',
                        },
                        '&.Mui-focused': {
                          background: theme.palette.mode === 'light'
                            ? 'rgba(255, 255, 255, 0.15)'
                            : 'rgba(30, 41, 59, 0.5)',
                          boxShadow: `0 0 0 3px ${theme.palette.mode === 'light'
                            ? 'rgba(16, 185, 129, 0.1)'
                            : 'rgba(59, 130, 246, 0.1)'}`,
                        }
                      },
                      '& .MuiInputBase-input': {
                        color: 'text.primary !important',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: `${theme.palette.divider} !important`,
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: 'text.secondary' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Button
                  fullWidth
                  size="small"
                  startIcon={<SortIcon />}
                  onClick={() => setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc')}
                  sx={{
                    borderRadius: 12,
                    border: `1px solid ${theme.palette.divider}`,
                    color: 'text.primary',
                    bgcolor: theme.palette.mode === 'light'
                      ? 'rgba(255, 255, 255, 0.05)'
                      : 'rgba(30, 41, 59, 0.3)',
                    '&:hover': {
                      bgcolor: theme.palette.mode === 'light'
                        ? 'rgba(255, 255, 255, 0.1)'
                        : 'rgba(30, 41, 59, 0.4)',
                    }
                  }}
                >
                  Sort: {sortOrder === 'desc' ? 'High to Low' : 'Low to High'}
                </Button>
              </GlassCard>
            )}

            <Box sx={{
              flex: 1,
              overflowY: 'auto',
              p: 2
            }}>
              {renderCustomerList()}
            </Box>
          </GlassPanel>

          {/* Main Content */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Header */}
            <GlassPanel sx={{ p: 2.25 }}>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}>
                <Box>
                  <Typography variant="h4" sx={{
                    fontWeight: 700,
                    mb: 0.5,
                    background: theme.palette.mode === 'light'
                      ? 'linear-gradient(135deg, #2d3748 0%, #4a5568 100%)'
                      : 'linear-gradient(135deg, #f1f5f9 0%, #cbd5e1 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}>
                    Customer Ledger
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Manage customer balances and transactions
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Button
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={refresh}
                    sx={{
                      borderRadius: 12,
                      border: `1px solid ${theme.palette.divider}`,
                      color: 'text.primary',
                      bgcolor: theme.palette.mode === 'light'
                        ? 'rgba(255, 255, 255, 0.85)'
                        : 'rgba(30, 41, 59, 0.85)',
                      '&:hover': {
                        bgcolor: theme.palette.mode === 'light'
                          ? 'rgba(16, 185, 129, 0.1)'
                          : 'rgba(59, 130, 246, 0.1)',
                        borderColor: theme.palette.mode === 'light'
                          ? 'rgba(16, 185, 129, 0.3)'
                          : 'rgba(59, 130, 246, 0.3)',
                      }
                    }}
                  >
                    Refresh
                  </Button>
                  {selectedCustomerDetails && (
                    <Chip
                      icon={<AccountCircleIcon />}
                      label={selectedCustomerDetails.name || 'Select Customer'}
                      sx={{
                        background: theme.palette.mode === 'light'
                          ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                          : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                        color: 'white',
                      }}
                    />
                  )}
                </Box>
              </Box>
            </GlassPanel>

            {/* Stats Cards */}
            <Box>
              {renderStatsCards()}
            </Box>

            {/* Transaction List */}
            <GlassPanel sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <Box sx={{
                p: 1.5,
                borderBottom: `1px solid ${theme.palette.divider}`
              }}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      Transactions
                    </Typography>
                    {selectedCustomerDetails && (
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        ({selectedCustomerTransactions.length})
                      </Typography>
                    )}
                  </Box>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Click on transaction to view details
                  </Typography>
                </Box>
              </Box>
              <Box sx={{
                flex: 1,
                overflowY: 'auto',
                p: 2
              }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {renderTransactionList()}
                </Box>
              </Box>
            </GlassPanel>
          </Box>
        </Box>

        {/* Transaction Detail Dialog */}
        <Dialog
          open={transactionDetailOpen}
          onClose={() => setTransactionDetailOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
              overflow: 'hidden',
              backgroundColor: 'transparent',
              boxShadow: 'none',
              maxHeight: '90vh',
            }
          }}
        >
          <DialogContent sx={{ p: 0, backgroundColor: 'transparent' }}>
            {renderTransactionDetail()}
          </DialogContent>
        </Dialog>

        {/* Scrollbar Styling */}
        <style>{`
         ::-webkit-scrollbar {
           width: 8px;
           height: 8px;
         }

         ::-webkit-scrollbar-track {
           background: transparent;
         }

         ::-webkit-scrollbar-thumb {
           background: ${theme.palette.divider};
           border-radius: 4px;
         }

         ::-webkit-scrollbar-thumb:hover {
           background: ${theme.palette.text.secondary};
         }
       `}</style>

        <PaymentManagementDialog
          open={paymentDialogOpen}
          onClose={() => {
            setPaymentDialogOpen(false);
            setSelectedTransactionForPayment(null);
          }}
          transaction={selectedTransactionForPayment}
          customer={selectedCustomerDetails}
          onPaymentComplete={handlePaymentComplete}
          recordPayment={handleRecordPayment}
          // Add fine balance info
          fineBalance={
            selectedTransactionForPayment?.transactionDetails?.finePayment?.balanceFine ||
            selectedTransactionForPayment?.summary?.fineBalance ||
            0
          }
          totalFineRequired={
            selectedTransactionForPayment?.transactionDetails?.finePayment?.requiredFine ||
            selectedTransactionForPayment?.summary?.fineRequired ||
            0
          }
          totalFinePaid={
            selectedTransactionForPayment?.transactionDetails?.finePayment?.totalFinePaid ||
            selectedTransactionForPayment?.summary?.finePaid ||
            0
          }
        />

        <BillSelectionDialog
          open={billSelectionOpen}
          onClose={() => {
            setBillSelectionOpen(false);
            setPendingBillsForCustomer([]);
          }}
          pendingTransactions={pendingBillsForCustomer}
          onSelectBill={handleBillSelection}
          formatCurrency={formatCurrency}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CustomerLedger;